import axios from "axios"
import { IXSifterNotificationListRequest, IXSifterUserNotificationList } from "../types/XSifterAppUser";

export const XSIFTER_GET_UNREAD_NOTIFICATION_COUNT = process.env.XSIFTER_BACKEND + "/user/notifications/unread";
export const XSIFTER_GET_NOTIFICATIONS = process.env.XSIFTER_BACKEND + "/user/notifications";

export default class NotificationsApiService {
    public async getUnreadNotificationsCount(token: string) : Promise<number> {
        return new Promise<number>((resolve, reject) => {
            axios.get(XSIFTER_GET_UNREAD_NOTIFICATION_COUNT, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(response.data.notificationCount);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    public async getNotifications(token: string, request: IXSifterNotificationListRequest) : Promise<IXSifterUserNotificationList> {
        return new Promise<IXSifterUserNotificationList>((resolve, reject) => {
            let queryParams = {
                'offset': request.offset,
                'limit': request.limit
            };
            if (request.sortField)
                queryParams["sort"] = `${request.sortField}:${request.sortDirection ?? "d"}`;

            if (request.archived)
                queryParams["archived"] = true;
            if (request.onlyUnread)
                queryParams["unreadOnly"] = true;

            axios.get(XSIFTER_GET_NOTIFICATIONS, {
                params: queryParams,
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }

    public async markNotificationRead(token: string, id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let url = `${XSIFTER_GET_NOTIFICATIONS}/${id}/read`;
            axios.post(url, null, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    }
    
    public async markNotificationArchived(token: string, id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let url = `${XSIFTER_GET_NOTIFICATIONS}/${id}/archive`;
            axios.post(url, null, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    }

    public async deleteNotification(token: string, id: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            let url = `${XSIFTER_GET_NOTIFICATIONS}/${id}`;
            axios.delete(url, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            }).then((response) => {
                resolve(true);
            }).catch((error) => {
                reject(false);
            });
        });
    }
};
